<template>
  <a-form layout="vertical">
    <a-form-item :label="t('shell.account.currentUsername')">
      <a-input :value="currentUsername" disabled />
    </a-form-item>
    <a-form-item :label="t('shell.account.newUsername')" required>
      <a-input v-model:value="form.newUsername" :placeholder="t('shell.account.newUsernamePlaceholder')" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" :disabled="!dirty" @click="handleSave">
        {{ t('shell.account.saveUsername') }}
      </a-button>
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { message } from 'ant-design-vue'
import { computed, reactive } from 'vue'
import { updateUsername } from '../../api/user/setting'
import { useI18n } from '../../composables/useI18n'

defineProps<{ currentUsername: string }>()
const emit = defineEmits<{ updated: [value: string] }>()
const { t } = useI18n()

const form = reactive({ newUsername: '' })
const dirty = computed(() => !!form.newUsername.trim())

async function handleSave() {
  const newUsername = form.newUsername.trim()
  if (!newUsername) {
    message.warning(t('shell.account.usernameRequired'))
    return
  }
  try {
    await updateUsername(newUsername)
    message.success(t('shell.account.usernameSuccess'))
    emit('updated', newUsername)
    form.newUsername = ''
  } catch (e: any) {
    message.error(e?.message || t('shell.account.updateFailed'))
  }
}
</script>
